import React from "react";
import './scills.css';
import UiUx from "./UiUx";
import Graphic from "./Graphic";
import Other from "./Other"

const Skills = () => {
    return(
       <section className="section skills" id="skills">
           <h2 className="section__title">
               Skills
           </h2>

           <span className="section__subtitle">
               My technical level
           </span>

           <div className="grid container skills__container">
                <UiUx/>
                <Graphic/>
                <Other/>
           </div>
       </section>
    )
}

export default Skills;
